import React, { useState, useEffect } from 'react';
import { Modal, Form, Select } from 'antd';
import useApi from '../../hooks/useApi';

const ModalAdd = ({ visible, onCancel, onConfirm, idGrupo }) => {
  const [form] = Form.useForm();
  const [categorias, setCategorias] = useState([]);
  const [selectedDashboard, setSelectedDashboard] = useState(null);

  const { callApi: addDashboardGrupo } = useApi(`https://vision.alfama.com/api/add/dashboards/grupo/${idGrupo}`, {
    method: 'POST',
    includeToken: true,
    successMessage: 'Dashboard adicionado com sucesso!',
    errorMessage: 'Erro ao adicionar Dashboard'
  });

  const { callApi: viewCategorias } = useApi('https://vision.alfama.com/api/view/dashboards/ativos', { 
    includeToken: true,
  });

  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        const response = await viewCategorias();
        if (response && Array.isArray(response)) {
          const formattedCategorias = response.map(categoria => ({
            value: categoria.dashboard_id,
            label: categoria.nome_dashboard
          }));
          setCategorias(formattedCategorias);
        }
      } catch (error) {
        console.error('Erro ao buscar categorias:', error);
      }
    };

    fetchCategorias();
  }, []);

  const handleFormValuesChange = (changedValues) => {
    if (changedValues.dashboard_id !== undefined) {
      setSelectedDashboard(changedValues.dashboard_id);
    }
  };

  const handleConfirm = async () => {
    try {
      const values = await form.validateFields();
      // Enviando o ID do dashboard como um valor único
      await addDashboardGrupo({ dashboard_id: values.dashboard_id });
      form.resetFields();
      setSelectedDashboard(null);
      onConfirm(true);
    } catch (error) {
      if (error.errorFields) {
        return;
      }
      console.error('Erro ao adicionar dashboard:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setSelectedDashboard(null);
    onCancel();
  };

  return (
    <Modal
      title="Vincular Dashboard"
      open={visible}
      onCancel={handleCancel}
      onOk={handleConfirm}
      okText="Adicionar"
      cancelText="Cancelar"
      maskClosable={false}
      width={500}
    >
      <Form
        form={form}
        layout="vertical"
        onValuesChange={handleFormValuesChange}
      >
        <Form.Item
          name="dashboard_id"
          label="Dashboard"
          rules={[{ required: true, message: 'Por favor, selecione um dashboard' }]}
        >
          <Select
            placeholder="Selecione um dashboard"
            options={categorias}
            loading={categorias.length === 0}
            showSearch
            optionFilterProp="label"
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalAdd;